export default "__VITE_ASSET__Bc3$$1O7__"